<template>
    <v-autocomplete
        v-if              = "items"
        v-model           = "selected"
        :items            = "items"
        item-value        = "id"
        item-text         = "name"
        :label            = "label"
        :background-color = "background"
        @change           = "onChange"
        auto-select-first
        return-object
        clearable
    />
</template>

<script>
export default {
    name: "MsdUsers",
    props: {
        value: {
            required: true
        },

        label: {
            required: false,
            default: function () {
                return 'Bearbeiter'
            }
        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null
            }
        }
    },

    data: () => ({
        selected: null
    }),

    mounted() {
        this.selected = this.value;
    },

    computed: {
        items () {
            return this.$store.getters.users.filter(u => u.ident !== 'TODO' && u.ident !== 'API User');
        }
    },

    methods: {
        onChange () {
            this.$emit('input', this.selected);
        },

//        text (item) {
//            return item.firstname + ' ' + item.lastname;
//        }
    }
}
</script>

<style scoped>

</style>